export default __webpack_public_path__ + "static/media/people-walking.f2a8843f.jpg";